import { string } from "prop-types";

import styled from "styled-components";

import FnrTypography from "FnrTypography";

import FnrContainedIcon from "UI/FnrContainedIcon";

const CloseButton = ({
  color,
  text = "Close",
  icon = "fa-chevron-circle-down fas",
  ...rest
}) => {
  return (
    <ActiveContainer {...rest}>
      <FnrContainedIcon color={color} size="xl" icon={icon} />
      <SFnrTypography bold noWrap type="copy" color={color}>
        {text}
      </SFnrTypography>
    </ActiveContainer>
  );
};

const ActiveContainer = styled.div`
  display: flex;
  align-items: center;
  padding-right: 12px;
`;

const SFnrTypography = styled(FnrTypography)`
  transform: translateY(-1px);
`;

CloseButton.propTypes = { color: string, text: string, icon: string };

export default CloseButton;
